module.exports = __webpack_public_path__ + "img/icon_mrvisit.3d1c1dc0.png";